import React, { useState } from "react";

import {
  Button,
  TextField,
  Stack,
  Box,
  CircularProgress,
  IconButton,
  Switch,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { Print, Delete, AddCircle } from "@mui/icons-material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/it";
import { green } from "@mui/material/colors";
import EmployeeSelect from "./EmployeeSelect";

const InputForm = (props) => {
  const [upload, setUpload] = useState("allow");

  const uploadSignature = (file) => {
    if (!file) return;

    setUpload("progress");

    try {
      props.input.signatures.push({
        url: URL.createObjectURL(file),
        name: btoa(file.name).replaceAll("=", "x"),
      });

      props.setInput({ ...props.input, signatures: props.input.signatures });
    } catch (error) {
      console.error(error);
    } finally {
      setUpload("allow");
    }
  };

  return (
    <Stack spacing={2}>
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              id="switch"
              sx={{ marginLeft: "12px" }}
              label="Certificati Interni"
              checked={props.input.internal}
              onChange={(e) => {
                props.setInput({
                  ...props.input,
                  names: [],
                  internal: e.target.checked,
                });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          label={
            props.input.internal ? "Certificati Interni" : "Certificati Esterni"
          }
        />
      </FormGroup>
      <TextField
        id="title"
        label="Titolo del corso"
        variant="outlined"
        onChange={(e) =>
          props.setInput({ ...props.input, title: e.target.value })
        }
      />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
        <DatePicker
          label="Data del corso"
          value={props.input.date}
          onChange={(v) =>
            console.log("a") || props.setInput({ ...props.input, date: v })
          }
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
      <TextField
        id="duration"
        label="Durata"
        variant="outlined"
        onChange={(e) =>
          props.setInput({ ...props.input, duration: e.target.value })
        }
      />
      <TextField
        id="id"
        label="ID corso"
        variant="outlined"
        onChange={(e) =>
          props.setInput({ ...props.input, trainingId: e.target.value })
        }
      />
      {props.input.internal ? (
        <EmployeeSelect input={props.input} setInput={props.setInput} />
      ) : (
        <TextField
          id="names"
          label="Nomi partecipanti (1 per riga)"
          variant="outlined"
          onChange={(e) =>
            props.setInput({
              ...props.input,
              names: e.target.value.trim().split("\n"),
            })
          }
          maxRows={10}
          multiline
        />
      )}
      <Box>
        {props.input.signatures.map((s) => (
          <Signature
            key={s.name}
            data={s}
            input={props.input}
            setInput={props.setInput}
          />
        ))}
      </Box>
      <Button
        startIcon={<AddCircle />}
        variant="contained"
        color="secondary"
        component="label"
        disabled={!["allow", "error"].includes(upload)}
      >
        Carica firma
        <input
          hidden
          accept="image/*"
          type="file"
          onChange={(e) => uploadSignature(e.target.files[0])}
        />
      </Button>
      <Box sx={{ m: 1, position: "relative" }}>
        <Button
          onClick={props.handlePrint}
          className="generate"
          variant="contained"
          color="primary"
          disableElevation
          startIcon={<Print />}
          disabled={
            JSON.stringify(props.template) === "{}" ||
            (!props.input.internal && !props.input.names.length) ||
            (props.input.internal && !props.input.selEmployees.length) ||
            props.loading
          }
        >
          Stampa certificati
        </Button>
        {props.loading && (
          <CircularProgress
            size={24}
            sx={{
              color: green[500],
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
          />
        )}
      </Box>
    </Stack>
  );
};

export default InputForm;

const Signature = (props) => {
  const [deleted, setDeleted] = useState(false);

  const deleteSelf = () => {
    const index = props.input.signatures.findIndex(
      (i) => i.name === props.data.name
    );

    props.input.signatures.splice(index, 1);

    props.setInput({ ...props.input, signatures: props.input.signatures });

    setDeleted(true);
  };

  if (deleted) return null;

  return (
    <Stack direction={"row"}>
      <img
        className="signature"
        id={`signature-${props.data.name}`}
        src={props.data.url}
        key={props.data.name}
        alt="Signature"
      />
      <IconButton color="error" variant="contained" onClick={deleteSelf}>
        <Delete />
      </IconButton>
    </Stack>
  );
};
